//@flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
//types
import { type Match } from 'react-router-dom';
import { type Currencies, type Currency } from '../../../utilities/types';
import {
  type DirectMerchantDetail,
  type PartnerDetail
} from '../components/types';
import CrudTableShow from '../../../modules/CrudTable/CrudTableShow';
import { dig, formatDate } from '../../../utilities/misc';
import PartnersTableRow from '../components/show/PartnersTableRow';
import PartnersTableHeader from '../components/show/PartnersTableHeader';
import DirectMerchantTableRow from '../components/show/DirectMerchantTableRow';
import DirectMerchantTableHeader from '../components/show/DirectMerchantTableHeader';
import {
  loadCommissionShow,
  changePage,
  updateLoadCommissionShow,
  expandDirectMerchantRow,
  expandPartnersRow,
  downloadCsv,
  setPerPageFilter,
  orderByDirectMerchantsProcessingVolume,
  orderByDirectMerchantsTransactionFee,
  orderByDirectMerchantsCommission,
  //
  orderByPartnersNumMerchants,
  orderByPartnersProcessingVolume,
  orderByPartnersTransactionFee,
  orderByPartnersCommission,
  orderByDirectMerchantsCreatedAt,
  orderByDirectMerchantsMerchantName,
  orderByPartnersCompanyName
} from './reducer';

import {
  makeGetCurrencyName,
  makeGetCurrencyColor,
  makeGetCurrencyType,
  makeGetCryptoWallet
} from './selectors';
import TableColumn from '../../../modules/CrudTable/components/TableColumn';
import SummaryFooter from './SummaryFooter';
import CustomCsv from './CustomCsv';
import { formatCurrency } from '../../../utilities/numberFormatting';
import {
  RequiresActionDiv,
  CustomDefaultIcon
} from './CommissionPaidShowStyles';
import RequiresAction from '../components/paid/RequiresAction';

type Props = {
  // Initialize
  loadCommissionShow: () => void,
  activeTable: string,
  match: Match,
  location: Location,
  loading: boolean,
  failedLoad: boolean,
  failedUpdateLoad: boolean,
  currencies: Currencies,
  currencyColor: string,
  currencyName: string,
  currencyType: string,
  downloadCsv: Function => void,
  cryptoWallet: string,

  //TableHeader
  // // DM
  orderByDirectMerchantsCreatedAt: () => void,
  orderByDirectMerchantsMerchantName: () => void,
  orderByDirectMerchantsProcessingVolume: () => void,
  orderByDirectMerchantsTransactionFee: () => void,
  orderByDirectMerchantsCommission: () => void,
  orderByDMCreatedAtState: number,
  orderByDMMerchantNameState: number,
  orderByDMProcessingVolumeState: number,
  orderByDMTransactionFeeState: number,
  orderByDMCommissionState: number,
  // // P
  orderByPartnersCompanyName: () => void,
  orderByPartnersNumMerchants: () => void,
  orderByPartnersProcessingVolume: () => void,
  orderByPartnersTransactionFee: () => void,
  orderByPartnersCommission: () => void,
  orderByPCompanyNameState: number,
  orderByPNumMerchantsState: number,
  orderByPProcessingVolumeState: number,
  orderByPTransactionFeeState: number,
  orderByPCommissionState: number,

  //Paginator
  paginatorTotal: number,
  currentPage: number,
  changePage: ({
    id: number | string,
    page: number
    // perPage: number
  }) => void,
  previouslyVisited: number[],
  // closeExpandedRow: null => void,

  //Paginator Filter
  perPageFilter: string,
  setPerPageFilter: () => void,

  // Summary
  summary: {
    transaction_amount: number,
    transaction_fee: number,
    revenue_share: number,
    transaction_count: number
  },

  updateLoadCommissionShow: ({
    id: string | number,
    newActiveTable: string
  }) => void,
  updateTableLoading: boolean,
  expandDirectMerchantRow: () => void,
  expandPartnersRow: () => void,
  loadCommissionShow: () => void,
  directMerchantExpandedRow: number,
  partnersExpandedRow: number,
  directMerchant: DirectMerchantDetail,
  partners: PartnerDetail,
  selectedIso: string,
  selectedCurrency: Currency,
  requiresBankAccount: boolean
};

type State = {
  // iso: number | string,
  id: string
};
class CommissionPaidShow extends Component<Props, State> {
  constructor(props) {
    super(props);
    const id = this.props.match.params.id || '';

    this.state = {
      id
    };
  }

  handleToggle = (directMerchantAction, partnerAction) => {
    switch (this.props.activeTable) {
      case 'Direct Merchants':
        return directMerchantAction;
      case 'Partners':
        return partnerAction;
      default:
        return;
    }
  };

  handleCsv = () => {
    const partners = `commission_payouts/${this.state.id}/referral_details`;
    const directMerchants = `commission_payouts/${this.state.id}/commissions`;
    return this.handleToggle(directMerchants, partners);
  };

  handleTableRow = () =>
    // $FlowFixMe
    this.handleToggle(<DirectMerchantTableRow />, <PartnersTableRow />);

  handleTableHeader = () =>
    this.handleToggle(
      <DirectMerchantTableHeader
        orderBy={{
          createdAt: this.props.orderByDirectMerchantsCreatedAt,
          merchantName: this.props.orderByDirectMerchantsMerchantName,
          processingVolume: this.props.orderByDirectMerchantsProcessingVolume,
          transactionFee: this.props.orderByDirectMerchantsTransactionFee,
          commission: this.props.orderByDirectMerchantsCommission
        }}
        orderState={{
          createdAt: this.props.orderByDMCreatedAtState,
          merchantName: this.props.orderByDMMerchantNameState,
          processingVolume: this.props.orderByDMProcessingVolumeState,
          transactionFee: this.props.orderByDMTransactionFeeState,
          commission: this.props.orderByDMCommissionState
        }}
      />,
      <PartnersTableHeader
        orderBy={{
          companyName: this.props.orderByPartnersCompanyName,
          numMerchants: this.props.orderByPartnersNumMerchants,
          processingVolume: this.props.orderByPartnersProcessingVolume,
          transactionFee: this.props.orderByPartnersTransactionFee,
          commission: this.props.orderByPartnersCommission
        }}
        orderState={{
          companyName: this.props.orderByPCompanyNameState,
          numMerchants: this.props.orderByPNumMerchantsState,
          processingVolume: this.props.orderByPProcessingVolumeState,
          transactionFee: this.props.orderByPTransactionFeeState,
          commission: this.props.orderByPCommissionState
        }}
      />
    );

  handleTableData = () =>
    this.handleToggle(this.props.directMerchant, this.props.partners);

  handleExpandRow = () =>
    this.handleToggle(
      this.props.expandDirectMerchantRow,
      this.props.expandPartnersRow
    );

  handleExpandedRow = () =>
    this.handleToggle(
      this.props.directMerchantExpandedRow,
      this.props.partnersExpandedRow
    );

  toggleTable = newActiveTable => {
    if (this.props.activeTable !== newActiveTable) {
      this.props.updateLoadCommissionShow({
        id: this.state.id,
        newActiveTable
      });
    }
  };

  dynamicTableColumnData = (status: string) => {
    const paymentMadeAt = dig(this.props.summary, 'payment_made_at') || '';
    const cryptoAddress = dig(this.props.summary, 'crypto_address') || '';
    const txid = dig(this.props.summary, 'txid') || '';
    const createdAt = dig(this.props.summary, 'created_at') || '';
    const pending = status.toLowerCase() === 'pending';
    if (!pending) {
      return [
        ['Date Created:', String(formatDate(createdAt))],
        ['Date Paid:', String(formatDate(paymentMadeAt))],
        ['Wallet Address:', cryptoAddress],
        ['TX Id:', txid]
      ];
    } else {
      return [];
    }
  };

  handleRequiresAction = (Component: Element<any>) => (
    <RequiresActionDiv>
      <div>
        <CustomDefaultIcon name="warning" colorName={'red'} />
      </div>
      {Component}
    </RequiresActionDiv>
  );

  requiresActionData = (status: string) => [
    <RequiresAction
      key={'SF2'}
      status={status}
      requiresCryptoWallet={!this.props.cryptoWallet}
      requiresBankAccount={this.props.requiresBankAccount}
      currencyName={this.props.currencyName}
      currencyType={this.props.currencyType}
      handleRequiresAction={this.handleRequiresAction}
    />
  ];

  render() {
    const payoutTotal = dig(this.props.summary, 'amount') || '';
    const processingVolumeTotal =
      dig(this.props.summary, 'total_processing_vol') || '';
    const transactionFeeTotal =
      dig(this.props.summary, 'total_transaction_fee') || '';
    const commissionCount = dig(this.props.summary, 'commission_count') || '';
    const status = dig(this.props.summary, 'status') || '';
    const tableData = this.handleTableData();

    return (
      <>
        <CrudTableShow
          // Initialize
          loadTableShowData={this.props.loadCommissionShow}
          location={this.props.location}
          match={this.props.match}
          loading={this.props.loading}
          currencies={this.props.currencies}
          failedLoad={this.props.failedLoad}
          failedUpdateLoad={this.props.failedUpdateLoad}
          // Paginator
          paginatorTotal={this.props.paginatorTotal}
          currentPage={this.props.currentPage}
          changePage={this.props.changePage}
          previouslyVisited={this.props.previouslyVisited}
          // Paginator Filter
          currentPerPage={this.props.perPageFilter}
          setPerPage={this.props.setPerPageFilter}
          perPageOptions={[10, 25, 50]}
          // Summary
          TableSummaryColumn={[
            <TableColumn
              first
              key={'SC1'}
              data={[
                [
                  'Total Processing Vol:',
                  formatCurrency(
                    processingVolumeTotal,
                    this.props.selectedCurrency
                  )
                ],
                [
                  'Transaction Fee Total:',
                  formatCurrency(
                    transactionFeeTotal,
                    this.props.selectedCurrency
                  )
                ],
                [
                  'Payout Total:',
                  formatCurrency(payoutTotal, this.props.selectedCurrency)
                ]
              ]}
            />,
            <TableColumn
              key={'SC2'}
              data={[...this.dynamicTableColumnData(status)]}
            />
          ]}
          TableSummaryFooter={[
            <SummaryFooter key={'SF1'} status={status} />,
            ...this.requiresActionData(status)
          ]}
          tableSummaryOptions={{
            title1: 'Payout Details:',
            title2: `${this.props.currencyName} Payout`,
            titleColor: this.props.currencyColor,
            subTitle: `Number of Transactions: ${commissionCount}`,
            hasHorizontalRule: true
          }}
          // Table Body
          updateTableLoading={this.props.updateTableLoading}
          tableData={tableData}
          tableBodyOptions={{
            text: 'No Transactions',
            model: 'Transactions',
            img: 'receipt',
            selectedIso: this.props.selectedIso
          }}
          TableRow={this.handleTableRow()}
          expandRow={this.handleExpandRow()}
          expandedRow={this.handleExpandedRow()}
          // Table Header
          TableHeader={this.handleTableHeader()}
          // Toggle
          tableToggleOptions={{
            sectionValue1: 'Direct Merchants',
            sectionValue2: 'Partners',
            RightAction: (
              <CustomCsv
                color={'blue'}
                downloadCsv={() => this.props.downloadCsv(this.handleCsv())}
              />
            ),
            activeSection: this.props.activeTable,
            handleClick: this.toggleTable
          }}
        />
      </>
    );
  }
}

// Needed for correct memoization when passing props to selectors https://github.com/reduxjs/reselect#accessing-react-props-in-selectors
const makeMapStateToProps = () => {
  const getCurrencyName = makeGetCurrencyName();
  const getCurrencyColor = makeGetCurrencyColor();
  const requiresBankAccount = makeGetCurrencyType();
  const getCryptoWallet = makeGetCryptoWallet();

  const mapStateToProps = (state, ownProps) => ({
    directMerchant: dig(
      state,
      'commissionPayouts',
      'commissionPaid',
      'show',
      'directMerchant',
      'commissions'
    ),
    orderByDMCreatedAtState:
      state.commissionPayouts.commissionPaid.show.directMerchant
        .orderByCreatedAtState,
    orderByDMMerchantNameState:
      state.commissionPayouts.commissionPaid.show.directMerchant
        .orderByMerchantNameState,
    orderByDMProcessingVolumeState:
      state.commissionPayouts.commissionPaid.show.directMerchant
        .orderByProcessingVolumeState,
    orderByDMTransactionFeeState:
      state.commissionPayouts.commissionPaid.show.directMerchant
        .orderByTransactionFeeState,
    orderByDMCommissionState:
      state.commissionPayouts.commissionPaid.show.directMerchant
        .orderByCommissionState,
    partners: dig(
      state,
      'commissionPayouts',
      'commissionPaid',
      'show',
      'partners',
      'referral_details'
    ),
    orderByPCompanyNameState:
      state.commissionPayouts.commissionPaid.show.partners
        .orderByCompanyNameState,
    orderByPNumMerchantsState:
      state.commissionPayouts.commissionPaid.show.partners
        .orderByNumMerchantsState,
    orderByPProcessingVolumeState:
      state.commissionPayouts.commissionPaid.show.partners
        .orderByProcessingVolumeState,
    orderByPTransactionFeeState:
      state.commissionPayouts.commissionPaid.show.partners
        .orderByTransactionFeeState,
    orderByPCommissionState:
      state.commissionPayouts.commissionPaid.show.partners
        .orderByCommissionState,

    cryptoWallet: getCryptoWallet(state, ownProps),
    currencyName: getCurrencyName(state, ownProps),
    currencyColor: getCurrencyColor(state, ownProps),
    currencyType: requiresBankAccount(state, ownProps),
    loading: state.commissionPayouts.commissionPaid.show.loading,
    summary: state.commissionPayouts.commissionPaid.show.summary,
    currencies: state.global.currencies,
    directMerchantExpandedRow:
      state.commissionPayouts.commissionPaid.show.directMerchant.expandedRow,
    partnersExpandedRow:
      state.commissionPayouts.commissionPaid.show.partners.expandedRow,
    currentPage: state.commissionPayouts.commissionPaid.show.currentPage,
    previouslyVisited:
      state.commissionPayouts.commissionPaid.show.previouslyVisited,
    paginatorTotal: state.commissionPayouts.commissionPaid.show.paginatorTotal,
    perPageFilter: state.commissionPayouts.commissionPaid.show.perPageFilter,
    updateTableLoading:
      state.commissionPayouts.commissionPaid.show.updateTableLoading,
    failedLoad: state.commissionPayouts.commissionPaid.show.failedLoad,
    failedUpdateLoad:
      state.commissionPayouts.commissionPaid.show.failedUpdateLoad,
    activeTable: state.commissionPayouts.commissionPaid.show.activeTable,
    selectedIso: state.commissionPayouts.commissionPaid.show.selectedIso,
    //TODO: make selector
    selectedCurrency:
      state.global.currencies[
        state.commissionPayouts.commissionPaid.show.selectedIso
      ],
    requiresBankAccount: state.account.bankAccount.formState === 'create'
  });
  return mapStateToProps;
};
const mapDispatchToProps = {
  loadCommissionShow,
  updateLoadCommissionShow,
  changePage,
  expandDirectMerchantRow,
  expandPartnersRow,
  downloadCsv,
  setPerPageFilter,
  orderByDirectMerchantsCreatedAt,
  orderByDirectMerchantsMerchantName,
  orderByDirectMerchantsProcessingVolume,
  orderByDirectMerchantsTransactionFee,
  orderByDirectMerchantsCommission,
  //
  orderByPartnersCompanyName,
  orderByPartnersNumMerchants,
  orderByPartnersProcessingVolume,
  orderByPartnersTransactionFee,
  orderByPartnersCommission
};

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(CommissionPaidShow);
